import React, { useState } from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import Table from "../../../components/table";
import withMiddleware from "../../../middleware";
import { useStyles } from "./style";
import { useUtils } from "../../../utils";
import { getEncPassword } from "../../../utils/encrypt";
import ChangePassword from "../users/change-password";
import { searchUsers, changePassword } from "./handler";

const columns = [
  { title: "Name", field: "name" },
  { title: "Email", field: "email" },
  { title: "Organization", field: "org_name" },
];

function UserPassword(props) {
  const classes = useStyles();
  const { showToast } = useUtils();
  const { service } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [changePasswordLoader, setChangePasswordLoader] = useState(false);

  async function handleSearch(value) {
    setKeyword(value);
    if (value.length <= 2) {
      setData([]);
      return;
    }
    try {
      setLoading(true);
      const users = await searchUsers(service, value);
      setData(users);
    } catch (err) {
      showToast("error", err.message || "Failed to search users");
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  function handleAction(e, row, key) {
    if (key !== "resetPassword") return;
    if (!row.email) {
      showToast("error", "This user has no email on file");
      return;
    }
    setSelectedUser(row);
    setOpenChangePassword(true);
  }

  async function handleChangePassword({ password }) {
    if (!selectedUser) return;
    try {
      setChangePasswordLoader(true);
      const passwordEnc = getEncPassword(password);
      const result = await changePassword(
        service,
        selectedUser.email,
        passwordEnc
      );
      showToast("success", result.message || "Password updated successfully");
      setOpenChangePassword(false);
      setSelectedUser(null);
    } catch (err) {
      showToast("error", err.message || "Failed to update password");
    } finally {
      setChangePasswordLoader(false);
    }
  }

  function closeChangePassword() {
    setOpenChangePassword(false);
    setSelectedUser(null);
  }

  return (
    <Grid className={classes.root}>
      <Grid className={classes.container}>
        <Typography variant="h6" gutterBottom>
          User Password
        </Typography>
        <TextField
          variant="outlined"
          placeholder="Search by name or email (min 3 characters)"
          fullWidth
          className={classes.searchField}
          value={keyword}
          onChange={(e) => handleSearch(e.target.value)}
          InputProps={{
            classes: { input: classes.input },
          }}
        />
        <Typography variant="body2" className={classes.hint}>
          Search results appear below. Use Reset Password only for email/password
          accounts.
        </Typography>
        <Table
          columns={columns}
          data={data}
          loading={loading}
          onActionClick={handleAction}
          options={{
            search: false,
            toolbar: false,
            paging: data.length > 10,
          }}
          actions={[
            {
              tooltip: "Reset Password",
              icon: "lock",
              key: "resetPassword",
              color: "primary",
            },
          ]}
        />
      </Grid>
      {openChangePassword && selectedUser && (
        <ChangePassword
          openChangePassword={openChangePassword}
          closeHandler={closeChangePassword}
          changePasswordHandler={handleChangePassword}
          loader={changePasswordLoader}
          userEmail={selectedUser.email}
        />
      )}
    </Grid>
  );
}

export default withMiddleware(UserPassword);
